import httpClient, { ExtendedAxiosRequestConfig } from '../../../../api/httpClient';
import { UserInitialDataDto } from '../models/user-initial-data.interface';

class UserInitialDataService {
  async getUserInitialDataByEmail(email: string): Promise<UserInitialDataDto[]> {
    try {
      // Configuración de caché para esta solicitud
      const cacheKey = `initial-data-${email}`;
      const config: ExtendedAxiosRequestConfig = {
        cache: {
          enabled: true, // Activar caché para esta solicitud
          duration: 30000, // 30 segundos de staleTime (datos considerados frescos)
          cacheTime: 5 * 60000, // 5 minutos en caché total antes de eliminarse
          key: cacheKey, // Clave única para esta solicitud
          refetchOnWindowFocus: false, // No recargar al enfocar la ventana
          retry: 1, // Reintentar una vez en caso de error
        },
      };

      const response = await httpClient.get<any>(`api/users/initial-data-by-email/${email}`, config);

      // Procesar la respuesta según su tipo
      if (!response) return [];
      if (Array.isArray(response)) return response;
      if (typeof response === 'object') return [response as UserInitialDataDto];
      return [];
    } catch (error) {
      return [];
    }
  }

  invalidateCache(email?: string): void {
    if (email) {
      const cacheKey = `initial-data-${email}`;
      import('./../../../../api/queryClient').then(({ queryClient }) => {
        queryClient.invalidateQueries({ queryKey: [cacheKey] });
      });
    } else {
      import('./../../../../api/queryClient').then(({ queryClient }) => {
        queryClient.invalidateQueries({ queryKey: ['initial-data'] });
      });
    }
  }
}

export default new UserInitialDataService();
